import banner from "./banner.jpg";
import logo from "./logo.jpg";
import sidebarLogo from "./sidebarlogo.png"

export const IMAGES = {
  BANNER: banner,
  LOGO: logo,
  SIDEBAR_LOGO: sidebarLogo,
};

/** Public profile URLs for header social icons — replace with your official pages. */
export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/share/1FAX5BWBuF/?mibextid=wwXIfr',
  linkedin: 'https://www.linkedin.com/company/grover-sweets/',
  instagram: 'https://www.instagram.com/groversweets?igsh=MW96cDRydGVuMWcxMA==',
};